__turbopack_context__.v({
  "customJustifyCenter": "header-module__tD4LIW__customJustifyCenter",
  "customSwiper": "header-module__tD4LIW__customSwiper",
  "dropdown": "header-module__tD4LIW__dropdown",
  "dropdownContainer": "header-module__tD4LIW__dropdownContainer",
  "dropdownContent": "header-module__tD4LIW__dropdownContent",
  "dropdownLeft": "header-module__tD4LIW__dropdownLeft",
  "dropdownRight": "header-module__tD4LIW__dropdownRight",
  "fadeIn": "header-module__tD4LIW__fadeIn",
  "logo": "header-module__tD4LIW__logo",
  "navLink": "header-module__tD4LIW__navLink",
  "searchDropdown": "header-module__tD4LIW__searchDropdown",
  "searchDropdownContainer": "header-module__tD4LIW__searchDropdownContainer",
  "slickSlide": "header-module__tD4LIW__slickSlide",
  "slideDown": "header-module__tD4LIW__slideDown",
  "slideDowns": "header-module__tD4LIW__slideDowns",
  "slideIn": "header-module__tD4LIW__slideIn",
  "slideIns": "header-module__tD4LIW__slideIns",
  "visible": "header-module__tD4LIW__visible",
  "visibles": "header-module__tD4LIW__visibles",
});
